export const SystemUserID = '1vY3mcQZj3QDop3k6rBiH5CFgWl'
export const CredentialResourceTypeID = '284NHv6xKcUKxFeBzGboCOAxQqz'
export const ManualRoleResourceTypeId = '2cKz6EqlO9FIWY5vK9oGWs1e776'
export const ManualGroupResourceTypeId = '2e40qJR3fvmcnnv5hC85lrGpIWq'
export const ManualCatalogResourceTypeId = '2kIhIXiJkqA93ryHkpdiHE6VOdT'
export const CredentialResourceID = '287oWNeXnXJl1IqmzTsLknmfw9a'
export const SecretResourceID = '2rQcPszUlrYE7lgSJ5VH3uyBjYw'
export const SystemAnyAccessEntitlementID = '287oY0rG4UirjDNFEYguMBvxyim'
export const CredentialCodeRequesterEntitlementID = '2RCowdtPmkzuIOBYSCKqpn1SkXn'
export const MutedDotsCacheKey = 'c1-muted-dots-cache'
export const catalogResourceTypeID = '2kIhIXiJkqA93ryHkpdiHE6VOdT'
export const LegacyProfileTypeID = '334YamiHeKSakdmuFXZjhc7dtng'

export enum RoleID {
    AccessRequestHelpdesk='2UOLcExDALM7FfzJsdZo4wqiMFJ',
    AccessRequestAdmin='2ULnq4sAV2SayEzD0vlW2GPmObJ',
    SuperAdmin='1lysP87nS0XUMc7bUqkxX1v0zU5',
    ReadOnlySystemLogs='2k1PVwVE5rLlQKZyLnYboZrTNkM',
    ReadOnlySuperAdmin='1lysWNakZXVPJd1WfPJHf6yy3rQ',
    BasicUser='1oaFKKRJ0fbzii9bImGEQAPwt9O',
    IntegrationAdmin='2E8EaOcKRncwH1LbavVvxrheftP',
    CampaignAdmin='24XUfkvXi5dVsx9WH02KuswUsdc',
    ApplicationAdmin='2uE7eIU44r9DcNNfsu95vhYThNq'
}

export const C1AppId = '2fsgTvxP0DVTsNXEUBI7hOe0l5A'

export const isC1ManagedApp = (appId: string): boolean => appId === C1AppId
export const isCatalogResourceType = (resourceTypeId: string): boolean => resourceTypeId === catalogResourceTypeID

export enum GrantReasonDerivedType {
    GrantReasonCatalogManual='GrantReasonCatalogManual',
    GrantReasonCatalogAutomation='GrantReasonCatalogAutomation',
    GrantReasonCatalogMembership='GrantReasonCatalogMembership',
    GrantReasonGroupManual='GrantReasonGroupManual',
    GrantReasonGroupAutomation='GrantReasonGroupAutomation',
    GrantReasonRequested='GrantReasonRequested'
}

// Builtin access config IDs for permission configurations on app resources
export enum BuiltinAccessConfigID {
    Org = '38fkNu017CxCVHP8QuRimNDEoNd',
    Members = '38fkTMNXxK5H0jb78YUaILEizjN',
    Owners = '38fkX2F9cXz08E6QQt9L0DHp7kg',
}
